import React, { lazy } from 'react';
import { Section } from './ui/Section';
export function InstructorTestimonials() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <Section className="bg-[#1A0F2E]/80" data-id="element-196">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-brand-title" data-id="element-197">
        ⭐ Lo que dicen los instructores que ya lo tienen
      </h2>
      <p className="text-center text-brand-textMuted mb-12 text-base tracking-wide font-body" data-id="element-198">
        Mensajes reales. Sin edición. Sin filtros.
      </p>

      {/* Instagram DMs Section */}
      <div className="mb-12" data-id="element-199">
        <p className="text-center text-brand-subtitle font-semibold mb-6 text-lg" data-id="element-200">
          📱 Nos escriben por Instagram...
        </p>
        <div className="flex justify-center" data-id="element-201">
          <img src="https://cdn.magicpatterns.com/uploads/hpC4Bo38Gd5YfusNTFgFBH/ChatGPT_Image_10_jun_2026,_08_50_33.webp" alt="Mensajes de Instagram de instructores" className="w-full max-w-[780px] rounded-2xl shadow-2xl" loading="lazy" data-id="element-202" />
        </div>
      </div>

      {/* Gmail Emails Section */}
      <div className="mb-12" data-id="element-203">
        <p className="text-center text-brand-subtitle font-semibold mb-6 text-lg" data-id="element-204">
          📩 ...y también por email
        </p>
        <div className="flex justify-center" data-id="element-205">
          <img src="https://cdn.magicpatterns.com/uploads/9rX8s3GxLcmHEMXBFupAPa/ChatGPT_Image_10_jun_2026,_08_55_10.webp" alt="Emails de instructores" className="w-full max-w-[780px] rounded-2xl shadow-2xl" loading="lazy" data-id="element-206" />
        </div>
      </div>

      {/* Closing Text */}
      <div className="text-center" data-id="element-207">
        <p className="text-brand-text text-lg md:text-xl font-semibold mb-2" data-id="element-208">
          +300 instructores en España ya enseñan con este sistema
        </p>
        <p className="text-brand-subtitle text-xl md:text-2xl font-bold mb-8" data-id="element-209">
          ¿Vas a ser el siguiente?
        </p>

        <button onClick={scrollToPricing} className="bg-gradient-gold hover:opacity-90 text-brand-bg font-bold text-xl md:text-2xl py-5 px-10 rounded-2xl transition-opacity w-full md:w-auto tracking-wide" data-id="element-210">
          🚀 ¡QUIERO EL MANUAL AHORA!
        </button>
      </div>
    </Section>;
}